import axios from 'axios';

export default {
    create(context, data) {

        var options = {
            url: window.apiUrl + '/exercise',
            method: 'POST',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    update(context, data) {

        var options = {
            url: window.apiUrl + '/exercise',
            method: 'PATCH',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    delete(context, id) {

        var options = {
            url: window.apiUrl + '/exercise',
            method: 'DELETE',
            data:{id: id},
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    submitHandIn(context, data) {

        var options = {
            url: window.apiUrl + '/hand-in',
            method: 'POST',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getHandIns(context, exerciseId) {

        var options = {
            url: window.apiUrl + '/hand-ins?exerciseId=' + exerciseId,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getForWeek(context, term, week) {

        var options = {
            url: window.apiUrl + '/exercises?term='+term+'&week=' + week,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getAll(context, week) {

        var options = {
            url: window.apiUrl + '/exercises',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/exercises/index.js